<template>
    <div>
        <template>
            <b-card-text>
                <b-table 
                    responsive
                    :fields="fields" 
                    striped hover 
                    :items="productos">
                    <template v-slot:cell(codigo_barras)="data">
                        {{ data.item.codigo_barras }}
                    </template>
                    <template v-slot:cell(codigo)="data">
                        {{ data.item.codigo }}
                    </template>
                    <template v-slot:cell(nombre_item)="data">
                        {{ data.item.nombre_item }}
                    </template>
                    <template v-slot:cell(cantidad)="data">
                        {{ data.item.cantidad }}
                    </template>
                    <template v-slot:cell(cliente_nit)="data">
                        {{ data.item.cliente_nit }}
                    </template>
                    <template v-slot:cell(valor_real_unit)="data">
                        {{ data.item.valor_real_unit }}
                    </template>
                    <template v-slot:cell(subtotal_items)="data">
                        $ {{numberFormat(data.item.subtotal_items) }}
                    </template>
                </b-table>
            </b-card-text>
        </template>
        <b-row> 
            <b-col cols="6" md="8">
                <div><b>Forma de Pago:</b></div>
                <div v-if="datos.metodo_pago == 1"><b>Efectivo</b></div>
                <div v-else-if="datos.metodo_pago == 2"><b>Tarjeta</b></div>
                <div v-else-if="datos.metodo_pago == 3"><b>Crédito</b></div>

            </b-col>
            <b-col cols="6" md="4" >
                <div><b>Total a pagar:</b> {{numberFormat(datos.monto_total)}}</div>
                <div><b>Pago:</b> {{numberFormat(datos.total_efectivo)}} </div>
                <div><b>Cambio:</b> {{numberFormat(datos.cambio_efectivo)}} </div>
                
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {
    props: ['productos', 'datos'],
    data() {
      return {
        fields: [
                { key: 'codigo_barras', label: 'Código de barras', sortable: true},
                { key: 'codigo', label: 'Código', sortable: true},
                { key: 'nombre_item', label: 'Nombre Artículo', sortable: true},
                { key: 'cantidad', label: 'Cantidad', sortable: true},
                { key: 'valor_real_unit', label: 'Vr. Unit', sortable: true},
                { key: 'subtotal_items', label: 'Subtotal', sortable: true},
            ],
        }
    }
    
}
</script>